import $ from 'jquery';
import slick from 'slick-carousel';
import anime from 'animejs/lib/anime.es.js';
import lottie from 'lottie-web';
import ConfettiGenerator from "confetti-js";
import Alpine from 'alpinejs'

window.Alpine = Alpine

Alpine.start()

const app = {

    resourcePath: '/wp-content/themes/bare-metal-child/resources',
    menu: false,
    thankyouID: 352,
    mq: window.matchMedia( "(max-width: 1120px)" ),

    init() {
        $('body').on('click', '#close-icon', (e) => {
            $('body').toggleClass('no-scroll');
            if (app.menu === false ? app.menu = true : app.menu = false);
            $('.mobile__navigation').slideToggle();
            if (app.menu === false ? toggle.playSegments([14, 27] ) : toggle.playSegments([0, 14]));
        });
        $('.search__icon').on('click', $.proxy(this.toggleSearch, this));
        $('.overlay').on('click', $.proxy(this.toggleSearch, this));


        $('body').on('click', '.brochure__button', (e) => {
            $('.brochure__form').toggle();
        });

        $('body').on('click', '.submenu__toggle', (e) => {
            const parent = $(e.currentTarget).parent();
            parent.find('.submenu').slideToggle();
        });

        let selector = $('body');
        if ( selector.hasClass(`page-id-${app.thankyouID}`) ) {
            var confettiSettings = { target: 'my-canvas' };
            var confetti = new ConfettiGenerator(confettiSettings);
            confetti.render();
        }


        $(document).scroll(function () {
            var $nav = $(".main-navigation");
            $nav.toggleClass('scrolled', $(this).scrollTop() > $nav.height());
    	});

        if (app.mq.matches) {
            // window width is at less than 570px
        } else {
            // window width is greater than 570px
            $(window).on('scroll', $.proxy(this.scrollFunction, this));
        }
        $(window).scroll( function(e) {
            if ($(this).scrollTop()) {
                $('#toTop').fadeIn();
            } else {
                $('#toTop').fadeOut();
            }
        });

    },

    toggleSearch() {
        $('.search').toggle();
        $('.overlay').toggle();
    },

    scrollFunction() {
          if (document.body.scrollTop > 50 || document.documentElement.scrollTop > 50) {

              $('.navigation__logo').addClass('normal');

          } else {
              $('.navigation__logo').removeClass('normal');
          }
      },
}

$(document).ready($.proxy(app.init, app));

var params3 = {
    container: document.getElementById('close-icon'),
    renderer: 'svg',
    loop: false,
    autoplay: false,
    path:  `${app.resourcePath}/animations/close-icon.json`,

};

var toggle;

toggle = lottie.loadAnimation(params3);
